import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class BranchService {

    private branchKey = 'key_live_mvwdzE3kEbquRGtiMy47lkgmEyoHaAOw';
    private endpoint = 'https://api2.branch.io/v1/url';
    branchIoLink!: string;

    constructor(private http: HttpClient) {
    }

    createBranchDeepLink(): Observable<string> {
        const clientId = sessionStorage.getItem('clientId');
        const tableId = sessionStorage.getItem('tableId');
        const orderId = localStorage.getItem('currentOrderId');
        const tableIdentifier = sessionStorage.getItem('tableIdentifier');
        const payload = {
            branch_key: this.branchKey,
            data: {
                clientId,
                tableId,
                orderId,
                tableIdentifier
            }
        };

        return this.http.post<{ url: string }>(this.endpoint, payload, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).pipe(
            map((response) => response.url),
            tap((url) => this.branchIoLink = url),
            catchError((error) => {
                console.error('Error creating Branch link:', error);
                return of('');
            })
        );
    }
} 